import { create } from "zustand";
import { fetchSupplyReport as apiFetchSupplyReport } from "../services/supplyReportService";

// Глобальний стор для сторінки "Очікуваний прихід"
export const useSupplyReportStore = create((set, get) => ({
  data: [],
  totalCount: 0,
  isLoading: true,

  filterPages: [
    { id: 1, name: "Готівка Польща" },
    { id: 2, name: "ОПТ Замовлення Україна" },
    { id: 3, name: "Прихід - Замовлення Польща на ТОВ ІМПОРТ" },
  ],

  filters: {
    search: "",
    filter_page: null,
    page: 1,
    page_size: 50,
    sort_by: "order_date",
    sort_asc: false,
  },

  // Ініціалізує стор при першому завантаженні сторінки
  init: async () => {
    get().initFiltersFromURL();
    await get().fetchData();
  },

  // Зчитує параметри з URL для відновлення попереднього стану фільтрів
  initFiltersFromURL: () => {
    const params = new URLSearchParams(window.location.search);
    set({
      filters: {
        ...get().filters,
        search: params.get("search") || "",
        filter_page: params.has("filter_page")
          ? parseInt(params.get("filter_page"), 10)
          : null,
        page: parseInt(params.get("page") || "1", 10),
        sort_by: params.get("sort_by") || "order_date",
        sort_asc: params.get("sort_asc") === "true",
      },
    });
  },

  // Оновлює URL-рядок для можливості ділитися посиланням на конкретну вибірку
  syncFiltersToURL: () => {
    const { filters } = get();
    const params = new URLSearchParams();

    // Тепер просто перевіряємо, чи є значення (відсікає null та undefined)
    if (filters.filter_page) params.set("filter_page", filters.filter_page);
    if (filters.search) params.set("search", filters.search);
    if (filters.page > 1) params.set("page", filters.page);
    if (filters.sort_by !== "order_date") params.set("sort_by", filters.sort_by);
    if (filters.sort_asc) params.set("sort_asc", "true");

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, "", newUrl);
  },

  // Перемикає сторінку пагінації
  setFilterPage: (filter_page) => {
    set((state) => ({
      filters: { ...state.filters, filter_page, page: 1 },
    }));
    get().syncFiltersToURL();
    get().fetchData();
  },

  // Змінює поле або напрямок сортування таблиці
  setSort: (field) => {
    const { sort_by, sort_asc } = get().filters;
    if (sort_by === field) {
      set((state) => ({
        filters: { ...state.filters, sort_asc: !sort_asc },
      }));
    } else {
      set((state) => ({
        filters: { ...state.filters, sort_by: field, sort_asc: true, page: 1 },
      }));
    }
    get().syncFiltersToURL();
    get().fetchData();
  },

  // Перемикає сторінку пагінації
  setPage: (page) => {
    set((state) => ({
      filters: { ...state.filters, page },
    }));
    get().syncFiltersToURL();
    get().fetchData();
  },

  // Здійснює пошук за ключовим словом
  setSearch: (value) => {
    set((state) => ({
      filters: { ...state.filters, search: value, page: 1 },
    }));
    get().syncFiltersToURL();
    get().fetchData();
  },

  // Асинхронно завантажує дані звіту з сервера
  fetchData: async () => {
    set({ isLoading: true });
    try {
      const { data, totalCount } = await apiFetchSupplyReport(get().filters);
      set({ data, totalCount });
    } catch (err) {
      console.error("Failed to fetch supply report data:", err);
      set({ data: [], totalCount: 0 });
    } finally {
      set({ isLoading: false });
    }
  },
}));
